import { cn } from '@/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md',
        'bg-gradient-to-r from-abyss-light/30 via-abyss-mid/50 to-abyss-light/30',
        'bg-[length:200%_100%]',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
